import { Link } from "react-router-dom";
import { Sparkles, Users, Wrench, BookOpen, ArrowRight, ShieldCheck } from "lucide-react";
import { PageHeader } from "@/components/common";

const CARDS = [
  ["/coach", Sparkles, "Ask Sidebizz", "Your AI business coach. Knows your business, stage and saved answers.", "bg-[#1E2B3C] text-white"],
  ["/coaching", Users, "Speak to a Business Coach", "Book a clarity call or launch session with a human coach.", "bg-white"],
  ["/tools", Wrench, "Recommended Tools", "Software we recommend for each stage of your business.", "bg-white"],
  ["/resources", BookOpen, "Resources & Templates", "Worksheets connected to the stage you're in.", "bg-white"],
  ["/sources", ShieldCheck, "Official Guidance", "Official Mauritius sources and documents behind every lesson.", "bg-white"],
];

export default function Help() {
  return (
    <div>
      <PageHeader eyebrow="Help" title="Get help when you need it" subtitle="AI guidance, human coaching, tools and templates — all connected to your journey." />
      <div className="grid sm:grid-cols-2 gap-4 stagger">
        {CARDS.map(([to, Icon, title, desc, cls]) => (
          <Link key={to} to={to} className={`rounded-2xl border border-[#EADEC9] p-6 hover:-translate-y-0.5 hover:shadow-md transition-[transform,box-shadow] ${cls}`} data-testid={`help-card-${to.slice(1)}`}>
            <Icon className="h-7 w-7 text-[#1DB99A]" />
            <div className="font-display font-extrabold text-lg mt-4">{title}</div>
            <p className={`text-sm mt-1 ${cls.includes("text-white") ? "text-white/70" : "text-[#5C6B73]"}`}>{desc}</p>
            <ArrowRight className="h-5 w-5 mt-4 text-[#1DB99A]" />
          </Link>
        ))}
      </div>
    </div>
  );
}
